import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth/AuthContext";
import { getDays } from "../api/daysService";
import { toast } from "react-toastify";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import { TextContext } from "../context/TextContext";

const GetDays = () => {
    const navigate = useNavigate();

    const { logoutUser } = useContext(AuthContext);
    const { setSharedText, setSelectedDate } = useContext(TextContext);

    const [isLoading, setIsLoading] = useState(true);
    const [days, setDays] = useState([]);

    useEffect(() => {
        setSharedText("سامانه حضور و غیاب");

        moment.loadPersian({
            dialect: "persian-modern",
            usePersianDigits: true,
        });

        submitHandler();
    }, []);

    const submitHandler = async () => {
        try {
            setIsLoading(true);

            const data = await getDays();
            setDays(data.days || []);
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "دریافت اطلاعات با خطا مواجه شد."
            );
        } finally {
            setIsLoading(false);
        }
    };

    const goToClassroom = (date) => {
        setSelectedDate(date);
        navigate("/classrooms");
    };

    const goToDayAbsences = (date) => {
        setSelectedDate(date);
        navigate("/day-absences");
    };

    return (
        <div className="attendance-page" dir="rtl">

            {/* Header */}
            <header className="attendance-header">

                <div className="header-right">
                    <div className="header-icon">
                        <svg
                            width="21"
                            height="21"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <rect
                                x="3"
                                y="4"
                                width="18"
                                height="17"
                                rx="4"
                                stroke="currentColor"
                                strokeWidth="1.8"
                            />
                            <path
                                d="M3 9H21"
                                stroke="currentColor"
                                strokeWidth="1.8"
                            />
                            <path
                                d="M8 2V5M16 2V5"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>

                    <div>
                        <h1>انتخاب تاریخ</h1>
                        {/* <span>روز موردنظر را انتخاب کنید</span> */}
                    </div>
                </div>


            </header>

            {/* Content */}
            <main className="attendance-content">

                {/* Loading */}
                {isLoading && (
                    <div className="loading">
                        <div className="spinner-border text-primary" />
                        <span>در حال دریافت اطلاعات...</span>
                    </div>
                )}

                {/* Days */}
                {!isLoading && days.length > 0 && (
                    <div className="days-container">

                        {days.map((day) => {

                            const date = day.date;

                            const dayName = moment(
                                date,
                                "YYYY-MM-DD"
                            ).format("dddd");

                            const formattedDate = moment(
                                date,
                                "YYYY-MM-DD"
                            ).format("jD jMMMM jYYYY");

                            return (
                                <div
                                    key={date}
                                    className="day-card"
                                    onClick={() =>
                                        goToClassroom(date)
                                    }
                                >

                                    {/* Main */}
                                    <div className="day-main">

                                        <div className="date-info">

                                            <div className="calendar-box">
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <rect
                                                        x="3"
                                                        y="4"
                                                        width="18"
                                                        height="17"
                                                        rx="4"
                                                        stroke="currentColor"
                                                        strokeWidth="1.7"
                                                    />
                                                    <path
                                                        d="M3 9H21"
                                                        stroke="currentColor"
                                                        strokeWidth="1.7"
                                                    />
                                                    <path
                                                        d="M8 2V5M16 2V5"
                                                        stroke="currentColor"
                                                        strokeWidth="1.7"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                            </div>

                                            <div className="date-text">
                                                <div className="day-name">
                                                    {dayName}
                                                </div>

                                                <div className="date">
                                                    {formattedDate}
                                                </div>
                                            </div>

                                        </div>

                                        <div
                                            className="day-actions"
                                            onClick={(e) =>
                                                e.stopPropagation()
                                            }
                                        >

                                            <div className="absence">
                                                <span>
                                                    غیبت
                                                </span>

                                                <strong>
                                                    {day.absenceCount}
                                                </strong>
                                            </div>

                                            <div className="dropdown">

                                                <button
                                                    type="button"
                                                    className="more-button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <svg
                                                        width="19"
                                                        height="19"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <circle
                                                            cx="12"
                                                            cy="5"
                                                            r="1.2"
                                                            fill="currentColor"
                                                        />
                                                        <circle
                                                            cx="12"
                                                            cy="12"
                                                            r="1.2"
                                                            fill="currentColor"
                                                        />
                                                        <circle
                                                            cx="12"
                                                            cy="19"
                                                            r="1.2"
                                                            fill="currentColor"
                                                        />
                                                    </svg>
                                                </button>

                                                <ul className="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <button
                                                            type="button"
                                                            className="dropdown-item"
                                                            onClick={() =>
                                                                goToDayAbsences(
                                                                    date
                                                                )
                                                            }
                                                        >
                                                            مشاهده غیبت‌ها
                                                        </button>
                                                    </li>
                                                </ul>

                                            </div>

                                        </div>

                                    </div>

                                    {/* Bottom */}
                                    <div className="card-bottom">
                                        <span>
                                            مشاهده کلاس‌ها
                                        </span>

                                        <svg
                                            width="17"
                                            height="17"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M9 18L15 12L9 6"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>

                                </div>
                            );
                        })}

                    </div>
                )}

                {/* Empty */}
                {!isLoading && days.length === 0 && (
                    <div className="empty">

                        <div className="empty-icon">
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <rect
                                    x="3"
                                    y="4"
                                    width="18"
                                    height="17"
                                    rx="4"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                />
                                <path
                                    d="M3 9H21"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                />
                                <path
                                    d="M8 2V5M16 2V5"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>

                        <h3>روزی وجود ندارد</h3>

                        <p>
                            هنوز اطلاعاتی برای نمایش ثبت نشده است.
                        </p>

                    </div>
                )}

            </main>

            <style>{`

                * {
                    box-sizing: border-box;
                }

                .attendance-page {
                    min-height: 100vh;
                    background: #f7f8fc;
                    color: #182033;
                }

                /* =========================
                   HEADER
                ========================= */

                .attendance-header {
                    height: 68px;
                    background: #726be7;
                    border-bottom: 1px solid #edf0f5;
                    color: white;
                    padding: 0 14px;

                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    position: sticky;
                    top: 0;
                    z-index: 100;
                }

                .header-right {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .header-icon {
                    width: 40px;
                    height: 40px;

                    border-radius: 12px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    background: #edf4ff;
                    color: #2563eb;
                }

                .header-right h1 {
                    font-size: 19px;
                    font-weight: 800;

                    margin: 0;
                }

                .header-right span {
                    display: block;

                    margin-top: 3px;

                    font-size: 10px;
                    color: #929aaa;
                }

                .menu-button {
                    width: 40px;
                    height: 40px;

                    padding: 0;

                    border: none;
                    border-radius: 11px;

                    background: #726be7;
                    color: white;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* =========================
                   CONTENT
                ========================= */

                .attendance-content {
                    width: 100%;
                    max-width: 600px;

                    margin: 0 auto;

                    padding: 14px 2px 30px;
                }

                /* =========================
                   DAYS
                ========================= */

                .days-container {
                    display: flex;
                    flex-direction: column;
                    gap: 9px;
                }

                .day-card {
                    background: #fff;

                    border: 1px solid #edf0f5;
                    border-radius: 15px;

                    padding: 13px;

                    box-shadow:
                        0 2px 8px rgba(20, 35, 60, 0.025);

                    cursor: pointer;

                    transition: all .18s ease;

                    -webkit-tap-highlight-color: transparent;
                }

                .day-card:active {
                    transform: scale(.985);
                    background: #fafbfe;
                }

                .day-main {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    gap: 8px;
                }

                /* =========================
                   DATE
                ========================= */

                .date-info {
                    min-width: 0;

                    display: flex;
                    align-items: center;

                    gap: 10px;
                }

                .calendar-box {
                    width: 42px;
                    height: 42px;

                    flex-shrink: 0;

                    border-radius: 11px;

                    background: #f0f5ff;
                    color: #2563eb;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .date-text {
                    min-width: 0;
                }

                .day-name {
                    font-size: 18px;
                    font-weight: 800;

                    white-space: nowrap;
                }

                .date {
                    margin-top: 3px;

                    color: #8d96a7;

                    font-size: 16px;

                    white-space: nowrap;
                }

                /* =========================
                   ACTIONS
                ========================= */

                .day-actions {
                    display: flex;
                    align-items: center;

                    gap: 4px;

                    flex-shrink: 0;
                }

                .absence {
                    display: flex;
                    flex-direction: column;

                    align-items: center;
                    justify-content: center;

                    min-width: 39px;
                }

                .absence span {
                    font-size: 9px;
                    color: #9aa2b1;
                }

                .absence strong {
                    margin-top: 2px;

                    min-width: 27px;
                    height: 30px;

                    padding: 0 5px;

                    border-radius: 8px;

                    background: #fff0f2;
                    color: #e11d48;

                    font-size: 20px;
                    font-weight: 800;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .more-button {
                    width: 36px;
                    height: 36px;

                    border: 0;
                    background: transparent;

                    border-radius: 9px;

                    color: #9aa2b1;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .more-button:active {
                    background: #f2f4f7;
                }

                /* =========================
                   BOTTOM
                ========================= */

                .card-bottom {
                    margin-top: 11px;
                    padding-top: 9px;

                    border-top: 1px solid #f2f3f6;

                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    color: #9aa2b1;

                    font-size: 10px;
                }

                .card-bottom svg {
                    transform: rotate(180deg);
                }

                /* =========================
                   LOADING
                ========================= */

                .loading {
                    min-height: 60vh;

                    display: flex;
                    flex-direction: column;

                    align-items: center;
                    justify-content: center;

                    gap: 12px;

                    color: #8d96a7;

                    font-size: 16px;
                }

                .loading .spinner-border {
                    width: 25px;
                    height: 25px;
                }

                /* =========================
                   EMPTY
                ========================= */

                .empty {
                    min-height: 60vh;

                    display: flex;
                    flex-direction: column;

                    align-items: center;
                    justify-content: center;

                    text-align: center;
                }

                .empty-icon {
                    width: 70px;
                    height: 70px;

                    border-radius: 20px;

                    background: #edf4ff;
                    color: #2563eb;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    margin-bottom: 14px;
                }

                .empty h3 {
                    margin: 0;

                    font-size: 15px;
                    font-weight: 800;
                }

                .empty p {
                    margin: 6px 0 0;

                    color: #929aaa;
                    font-size: 11px;
                }

                /* =========================
                   SMALL PHONES
                ========================= */

                @media (max-width: 360px) {

                    .attendance-header {
                        padding: 0 10px;
                    }

                    .attendance-content {
                        padding-left: 9px;
                        padding-right: 9px;
                    }

                    .day-card {
                        padding: 11px;
                    }

                    .calendar-box {
                        width: 39px;
                        height: 39px;
                    }

                    .day-name {
                        font-size: 13px;
                    }

                    .date {
                        font-size: 9px;
                    }

                    .card-bottom {
                        font-size: 9px;
                    }
                }

                /* =========================
                   DESKTOP
                ========================= */

                @media (min-width: 768px) {

                    .attendance-header {
                        padding: 0 24px;
                    }

                    .attendance-content {
                        padding-top: 24px;
                    }

                    .day-card:hover {
                        transform: translateY(-2px);

                        border-color: #dce6fa;

                        box-shadow:
                            0 8px 25px rgba(20, 35, 60, .07);
                    }

                    .day-card:hover .card-bottom {
                        color: #2563eb;
                    }
                }

            `}</style>
        </div>
    );
};

export default GetDays;